import * as React from 'react';

import A11yAnnouncer from '../A11yAnnouncer/A11yAnnouncer';

const AddToCartA11yAnnouncer = (props: { quantity: number | undefined }) => {
    let quantityLabel;
    if (props.quantity === 0) {
        quantityLabel = 'Denna vara är borttagen från varukorgen.';
    }

    if (props.quantity === 1) {
        quantityLabel = 'Denna vara finns nu i varukorgen.';
    }

    if (props.quantity !== undefined && props.quantity > 1) {
        quantityLabel = `${props.quantity} av denna vara finns i varukorgen.`;
    }

    return <A11yAnnouncer announcerName="AddToCart" text={quantityLabel} />;
};

export default React.memo(AddToCartA11yAnnouncer);
